/* Frounder v3 — shared behaviour: scroll reveals + studio-shot detection for the custom sections */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(root) {
    var nodes = Array.prototype.slice.call((root || document).querySelectorAll('.fr-rv:not(.fr-in)'));
    if (!nodes.length) return;
    if (RM || !('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('fr-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      var i = 0;
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var n = e.target; setTimeout(function () { n.classList.add('fr-in'); }, (i++) * 70); io.unobserve(n);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }
  /* cut-out studio shot (white ground → blended onto the plate) or a photograph (→ cover)?
     Samples eight edge points; a white ground with at most two samples on the subject counts as a cut-out. */
  function isStudio(img, lim) {
    try {
      var c = document.createElement('canvas'); c.width = c.height = 24;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, 24, 24);
      var d = x.getImageData(0, 0, 24, 24).data, pts = [[1,1],[22,1],[1,22],[22,22],[12,1],[1,12],[22,12],[12,22]], light = 0;
      pts.forEach(function (p) { var k = (p[1] * 24 + p[0]) * 4; if (Math.min(d[k], d[k+1], d[k+2]) > (lim || 215)) light++; });
      return light >= 6;
    } catch (e) { return null; }
  }
  function classify(root) {
    var imgs = Array.prototype.slice.call((root || document).querySelectorAll('.fcl-plate img, .ft-plate img, .fc-plate img'));
    imgs.forEach(function (img) {
      if (img.dataset.frCls) return; img.dataset.frCls = '1';
      var run = function () { var s = isStudio(img); if (s === null) return; img.classList.toggle('cover', !s); };
      if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
    });
  }
  window.frReveal = reveal; window.frClassify = classify;
  reveal(); classify();
  /* the theme editor re-renders sections in place */
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); classify(e.target); });
})();
